import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PivotFieldListComponent } from './pivotfieldlist.component';
/**
 * NgModule definition for the PivotFieldList component.
 */
export class PivotFieldListModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        PivotFieldListComponent
    ],
    exports: [
        PivotFieldListComponent
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function PivotFieldListModule_tsickle_Closure_declarations() {
/** @type {?} */
PivotFieldListModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PivotFieldListModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
